// Typography tokens — Poppins, display/text scales, weights

export const typography = {
  fontFamily:
    "'Poppins', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",

  // Display headlines: SemiBold (600), letter-spacing -0.02em
  display: {
    xl: { fontSize: 60, lineHeight: 72 },
    lg: { fontSize: 48, lineHeight: 60 },
    md: { fontSize: 36, lineHeight: 44 },
    sm: { fontSize: 30, lineHeight: 38 },
    xs: { fontSize: 24, lineHeight: 32 },
  },

  // Body text: Medium (500), default tracking
  text: {
    xl: { fontSize: 20, lineHeight: 30 },
    lg: { fontSize: 18, lineHeight: 28 },
    md: { fontSize: 16, lineHeight: 24 },
    sm: { fontSize: 14, lineHeight: 20 },
    xs: { fontSize: 12, lineHeight: 18 },
  },

  eyebrow: { fontSize: 14 },

  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
  },

  displayTracking: '-0.02em',
  headingTracking: '-0.01em', // for h4 / xs display
} as const

export type Typography = typeof typography
